import i18n from 'i18next';
import en from './en.json';

i18n.addResourceBundle('en', 'portal', en);
